import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { commentaryData } from "../../features/commentary/commentarySlice";
import styles from "./Commentary.module.css";
import CommentaryProvider from "./CommentaryProvider";
import { Forward10Outlined } from "@mui/icons-material";



const Commentary = () => {
  const { match_id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.commentary.data);
  const pending = useSelector((state) => state.commentary.pending);
  const error = useSelector((state) => state.commentary.error);
  const finalData = data.data;

  

  const[Inning1, setInning1] = useState(true)
  const[Inning2, setInning2] = useState(false)
  const[Inning3, setInning3] = useState(false)
  const[Inning4, setInning4] = useState(false)
  const[activeInning, setactiveInning] = useState('inning1')

  const handleClick = (inning) =>{

    switch(inning){
      case 'inning1':
        setInning1(true)
    setInning2(false)
    setInning3(false)
    setInning4(false)
    break;
    case 'inning2':
        setInning1(false)
    setInning2(true)
    setInning3(false)
    setInning4(false)
    break;
    case 'inning3':
        setInning1(false)
    setInning2(false)
    setInning3(true)
    setInning4(false)
    break;
    case 'inning4':
        setInning1(false)
    setInning2(false)
    setInning3(false)
    setInning4(true)
    break;
    default:
      return null
    }
    setactiveInning(inning)

  }
  useEffect(() => {
   
      dispatch(commentaryData(match_id));
   
    
  }, [dispatch, match_id]);
 

  return (

    <div className={styles.parent}>
   
      <div className={styles.inning}>
        <div className={` ${ Inning1 === true  ? styles.active : styles.inactive} ${styles.inningNumber} `} onClick={()=>{handleClick('inning1')}} >
          <span> Inning1 </span>
        </div>
        <div className={`${ Inning2 === true  ? styles.active : styles.inactive} ${styles.inningNumber} ${finalData && !finalData['2 Inning'] ? styles.disabled : styles.enable} `} onClick={()=>{handleClick('inning2')}}>
          <span>Inning2 </span>
          </div>
        <div className={`${ Inning3 === true  ? styles.active : styles.inactive} ${styles.inningNumber} ${finalData && !finalData['3 Inning'] ? styles.disabled : styles.enable} `} onClick={()=>{handleClick('inning3')}}>
          <span>Inning3 </span>
          </div>
        <div className={`${ Inning4 === true  ? styles.active : styles.inactive} ${styles.inningNumber} ${finalData && !finalData['4 Inning'] ? styles.disabled : styles.enable} `} onClick={()=>{handleClick('inning4')}}>
          <span>Inning4 </span>
          
        </div>
        
      </div>
      <div className={styles.commentaryWrapper}>
      <div className={styles.commentaryContainer}>
        
        {<CommentaryProvider activeInning = {activeInning} /> }
      </div>

      

     
        
    
    </div>
    </div>
  );
};

export default Commentary;
